import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { brooklynConfig } from "./data";

export default function BrooklynPage() {
  return <CityPageTemplate config={brooklynConfig} />;
}